import api from './api';

export const getDepartments = (params = {}) => {
  return api.get('/departments', { params }).then(response => {
    // If it's a search request or no pagination params, return full response
    if (params.search || !params.page) {
      return response.data;
    }
    // For paginated list, return the data array and pagination info
    return {
      data: response.data.data,
      last_page: response.data.last_page
    };
  });
};

export const getDesignations = () => {
  return api.get('/designations');
};

export const searchDepartments = (searchTerm) => {
  return api.get(`/departments/search?search=${searchTerm}`);
};

export const createDepartment = (departmentData) => {
  return api.post('/departments', departmentData);
};

export const getDepartment = (id) => {
  return api.get(`/departments/${id}`);
};

export const updateDepartment = (id, departmentData) => {
  return api.put(`/departments/${id}`, departmentData);
};

export const deleteDepartment = (id) => {
  return api.delete(`/departments/${id}`);
};